import { NavLink } from 'react-router-dom';

import useGlobalStore from 'hooks/useGlobalStore';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const NavigationLink: FunctionComponent<Props> = ({
    className = '',
    isExactMatch = false,
    onClick,
    testId = TEST_ID,
    text = '',
    to
}) => {
    const { getValue, setValue } = useGlobalStore({
        namespace: 'useNavigation'
    });

    const isBlocked = getValue('isBlocked');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = (event: any) => {
        if (isBlocked) {
            event.preventDefault();

            setValue({ blockedNavigation: true });

            setValue({ blockedPath: to });

            return;
        }

        setValue({ blockedNavigation: false });

        onClick?.();
    };

    return (
        <NavLink
            className={({ isActive }) =>
                `${className} ${styles.navigationLink} ${isActive ? styles.linkActive : ''}`
            }
            data-testid={testId}
            end={isExactMatch}
            onClick={handleClick}
            to={to}
        >
            {text}
        </NavLink>
    );
};

export default NavigationLink;
